import { Navigate, useLocation } from "react-router-dom";

import { localizedPath } from "@/lib/nav";

/** Legacy /features URLs → merged agent product page. */
export function FeaturesRedirect() {
  const location = useLocation();
  return <Navigate to={localizedPath(location.pathname, "/")} replace />;
}
